import { Link } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

const features = [
  {
    icon: "map",
    title: "Live Dispatch Map",
    body: "Every bus tracked in real time. Dispatchers see the full picture and catch delays before they happen.",
  },
  {
    icon: "smartphone",
    title: "Driver Mobile App",
    body: "Clock in, view assignments, and navigate — all from our purpose-built iOS and Android app.",
  },
  {
    icon: "smart_toy",
    title: "Eve AI Assistant",
    body: "Drivers ask \"Hey Eve\" hands-free for trip details and schedule updates while keeping eyes on the road.",
  },
  {
    icon: "forum",
    title: "Unified Messaging",
    body: "Dispatch reaches every driver through push alerts, voice radio, and SMS simultaneously.",
  },
];

function TechTeaser() {
  return (
    <MKBox component="section" py={8} sx={{ background: "linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)" }}>
      <Container>
        <Grid container justifyContent="center" mb={5}>
          <Grid item xs={12} md={8} textAlign="center">
            <MKTypography variant="h3" color="white" mb={1}>
              Powered by Proprietary Technology
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
              We built our own dispatch platform so nothing falls through the cracks. Every trip
              is tracked, every driver is connected, every customer gets on-time service.
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3} justifyContent="center" mb={5}>
          {features.map(({ icon, title, body }) => (
            <Grid item xs={12} sm={6} md={3} key={title}>
              <MKBox
                textAlign="center"
                p={3}
                borderRadius="lg"
                sx={{ background: "rgba(255,255,255,0.08)", height: "100%" }}
              >
                <Icon sx={{ fontSize: "2.5rem", color: "#90caf9", mb: 1 }}>{icon}</Icon>
                <MKTypography variant="h6" color="white" mb={1}>{title}</MKTypography>
                <MKTypography variant="body2" color="white" opacity={0.75}>{body}</MKTypography>
              </MKBox>
            </Grid>
          ))}
        </Grid>
        <MKBox textAlign="center">
          <MKButton component={Link} to="/technology" variant="contained" color="white" size="large">
            See How It Works
          </MKButton>
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default TechTeaser;
